// Shared helpers for running a workflow (the code-step runner lives in
// code/run.js): step input wiring, readable table labels and the error type.
//
// Workflow shape:
//   {
//     sources: [{ id: "source1", label, ... }],
//     steps:   [{ id: "step1", type, inputs?: ["source1"], params, label?, disabled? }],
//     outputs: [{ id: "output1", ... }]          // see outputs.js
//   }
// A step without `inputs` reads the previous step's result (or the first
// source for the first step).
import { getStepDefinition } from "./registry";
import "./steps";

export class WorkflowError extends Error {
  constructor(message, { stepId, details } = {}) {
    super(message);
    this.name = "WorkflowError";
    this.stepId = stepId;
    this.details = details;
  }
}

export const stepInputs = (workflow, stepIndex) => {
  const step = workflow.steps[stepIndex];
  // An explicit list (possibly empty: disconnected) wins; otherwise the default.
  if (Array.isArray(step.inputs)) return step.inputs;
  if (stepIndex > 0) return [workflow.steps[stepIndex - 1].id];
  return workflow.sources?.[0] ? [workflow.sources[0].id] : [];
};

export const tableLabel = (workflow, id) => {
  const source = workflow.sources?.find((s) => s.id === id);
  if (source) return source.label ? `${source.label} (${id})` : id;
  const index = workflow.steps.findIndex((s) => s.id === id);
  if (index === -1) return id;
  const step = workflow.steps[index];
  const name = step.label || getStepDefinition(step.type)?.label || step.type;
  return `Step ${index + 1} · ${name}`;
};
